import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
  DropdownMenu,
  Box,
  DropdownMenuMenuItem,
  DropdownMenuCustomTriggerProps,
} from '@ally/metronome-ui';
import { DropDownLink, LI } from '../../atoms';
import { AccountListNav } from '../../molecules';
import { INavLinkDetail } from '../../../models';
import { ISubLink } from '../../../interfaces';
import { NavSubMenuLink } from '../../organisms';

const StyledBox = styled(Box)`
  -webkit-box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.15);
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.15);
`;

interface IProps {
  children?: React.ReactNode;
  navItem: INavLinkDetail;
}

const MainNavMenu: React.FC<IProps> = (props) => {
  const buildDropdownItems = (): DropdownMenuMenuItem[] => {
    if (!props.navItem.subLinks) return [];

    return props.navItem.subLinks.map((subNavItem: ISubLink) => {
      if (subNavItem.subComponent === 'AccountListNav') {
        return {
          variant: 'custom' as const,
          _uuid: subNavItem.title,
          item: ({
            handleSelect,
          }: {
            active?: boolean;
            handleSelect: () => void;
          }) => (
            <StyledBox
              maxHeight='264px'
              overflowY='auto'
              key={subNavItem.title}
              width={['224px', '224px', '224px', '380px']}
            >
              <AccountListNav />
            </StyledBox>
          ),
        };
      }

      if (subNavItem.transmitdestination) {
        return {
          variant: 'custom' as const,
          item: () => (
            <NavSubMenuLink
              isBold
              subLink={subNavItem}
              key={subNavItem.title}
            />
          ),
          _uuid: subNavItem.title,
        };
      }

      return {
        variant: 'link' as const,
        text: subNavItem.title,
        href: subNavItem.link,
        _uuid: subNavItem.title,
      };
    });
  };

  const NavTrigger = forwardRef<
    HTMLButtonElement,
    DropdownMenuCustomTriggerProps
  >(({ open, referenceProps, menuTitle }, ref) => (
    <button
      ref={ref}
      {...referenceProps}
      style={{ all: 'unset', cursor: 'pointer' }}
    >
      <DropDownLink type='nav'>{menuTitle}</DropDownLink>
    </button>
  ));

  return (
    <LI>
      <DropdownMenu
        title={props.navItem.title}
        dropdownItems={buildDropdownItems()}
        trigger={NavTrigger}
        ariaLabelTrigger={(isOpen, title) => `${title} menu`}
      />
    </LI>
  );
};

export default MainNavMenu;
